export var MenuElementType;
(function (MenuElementType) {
    MenuElementType["Multichoice"] = "multichoice";
    MenuElementType["FreeText"] = "free-text";
    MenuElementType["GoToEditPage"] = "go-to-edit-page";
})(MenuElementType || (MenuElementType = {}));
export var FirstLevelAnswerElementType;
(function (FirstLevelAnswerElementType) {
    FirstLevelAnswerElementType["Options"] = "firstlevel-options";
    FirstLevelAnswerElementType["OptionsWithEdit"] = "firstlevel-options-with-edit";
    FirstLevelAnswerElementType["OptionsWithCustomEdit"] = "firstlevel-options-with-custom-edit";
    FirstLevelAnswerElementType["Multichoice"] = "firstlevel-multichoice";
    FirstLevelAnswerElementType["MultichoiceWithEdit"] = "firstlevel-multichoice-with-edit";
    FirstLevelAnswerElementType["FreeText"] = "firstlevel-free-text";
    FirstLevelAnswerElementType["ImageTags"] = "firstlevel-image-tags";
})(FirstLevelAnswerElementType || (FirstLevelAnswerElementType = {}));
export var AnswerJustifyContent;
(function (AnswerJustifyContent) {
    AnswerJustifyContent["Start"] = "start";
    AnswerJustifyContent["Center"] = "center";
    AnswerJustifyContent["End"] = "end";
})(AnswerJustifyContent || (AnswerJustifyContent = {}));
//# sourceMappingURL=answers.types.js.map